import { FC } from 'react'

import styled from 'styled-components'

import InfoIcon from 'src/Assets/Svg/common/info.svg?react'
import { renderLanguageOrGenreName } from 'src/Components/GenresList/helpers'
import CrossIcon from 'src/Assets/Svg/common/fullCross.svg?react'

const Container = styled.div`
  display: flex;
  padding-bottom: 8px;
  align-items: flex-start;
  align-content: flex-start;
  gap: 8px;
  align-self: stretch;
  flex-wrap: wrap;
`

const Item = styled.div<{ $isSelected: boolean }>`
  display: flex;
  padding: 9.5px 12px;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme, $isSelected }) =>
    $isSelected ? theme.color.darkGreen : 'transparent'};
  background: ${({ theme }) => theme.color.lightGreen};
  color: ${({ theme }) => theme.color.darkGreen};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  cursor: pointer;
`

const Title = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`
const NoResults = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`
const NoResultsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`

type Props = {
  countries: string[]
  searchValue?: string
  selectedCountries: string[]
  onCountryClick: (country: string) => void
}

export const CustomCountriesSearchList: FC<Props> = ({
  countries,
  searchValue,
  selectedCountries,
  onCountryClick,
}) => {
  const filteredCountries = countries.filter((country) =>
    country.toLowerCase().includes(searchValue?.toLowerCase() || ''),
  )
  if (!filteredCountries || filteredCountries.length === 0) {
    return (
      <>
        <Title>{searchValue ? 'Search results' : 'A-Z'}</Title>
        <NoResultsContainer>
          <InfoIcon width={16} height={16} />
          <NoResults>No search results</NoResults>
        </NoResultsContainer>
      </>
    )
  }

  return (
    <>
      <Title>{searchValue ? 'Search results' : 'A-Z'}</Title>
      <Container>
        {filteredCountries.map((country) => {
          const isSelected = selectedCountries.includes(country)
          return (
            <Item
              $isSelected={isSelected}
              key={country}
              onClick={() => onCountryClick(country)}
            >
              {renderLanguageOrGenreName(country, searchValue || '')}
              {isSelected && <CrossIcon width={16} height={16} />}
            </Item>
          )
        })}
      </Container>
    </>
  )
}
